import { render, staticRenderFns } from "./PrivateImageCard.vue?vue&type=template&id=4816e03a&"
import script from "./PrivateImageCard.vue?vue&type=script&lang=js&"
export * from "./PrivateImageCard.vue?vue&type=script&lang=js&"
import style0 from "./PrivateImageCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports